export default __webpack_public_path__ + "static/media/Snd_TryR.94802140.mp3";